import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"
import {enter, leave} from "el-transition"

export default class extends Controller {
  static targets = [ "button", "dropdown" ]

  connect() {
    useClickOutside(this)
  }

  toggle() {
    if (this.buttonTarget.getAttribute("aria-expanded") == "false") {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    enter(this.dropdownTarget)
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  hide() {
    leave(this.dropdownTarget)
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  clickOutside() {
    this.hide()
  }

  teardown() {
    this.hide()
  }
}

